module.exports = __webpack_public_path__ + "static/media/16.175dcf5f.jpg";